import { useEffect } from 'react';
import DefaultNavbar from 'components/DefaultNavbar';
import DefaultFooter from 'components/DefaultFooter';
import Header from 'components/Semovi/Header';
import TermnsSection from 'components/Semovi/TermsSection';

export default function Termns() {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])
    return (
        <>
            <DefaultNavbar />
            <main>
                <Header />
                <TermnsSection />
            </main>
            <DefaultFooter />
        </>
    );
}
